/**
 * Centralized application version
 * Increment this version when releasing new updates
 */
export const APP_VERSION = 'v0.1.2';